import { Slide, TableOptions } from '@features/powerpoint';
import {
  MinimumsTableData,
  minimumsTable,
} from '../../components/minimums-table';
import { columnLabels, MediumMinimums } from './column-labels';
import { categoryLabels } from './category-labels';

const mediumMinimums: readonly MediumMinimums[] = [
  {
    name: categoryLabels.digitalLciMobileApp,
    visitMinimums: '~1M Impressions',
    attributionMinimums: '10M Impressions',
  },
  {
    name: categoryLabels.digitalLciMobileWeb,
    visitMinimums: '~1-5M Impressions',
    attributionMinimums: '25M Impressions',
  },
  {
    name: categoryLabels.digitalLciConnectedTv,
    visitMinimums: '~1-5M Impressions',
    attributionMinimums: '15M Impressions',
  },
  {
    name: categoryLabels.tvLciLinear,
    visitMinimums: '10-25M HHs, depending on TV partner',
    attributionMinimums: '10-25M HHs, depending on TV partner',
  },
  {
    name: categoryLabels.tvLciAddressable,
    visitMinimums: '1M HHs per operator',
    attributionMinimums: '1M HHs per operator',
  },
  {
    name: categoryLabels.websiteLci,
    visitMinimums: '~1-5M Pageviews/LCI Pixel Fires',
    attributionMinimums: '25M Pageviews/LCI Pixel Fires',
  },
  {
    name: categoryLabels.oohLci,
    visitMinimums: '~1M Users',
    attributionMinimums: '~1M Users',
  },
  {
    name: categoryLabels.directMail,
    visitMinimums: '~1M HHs',
    attributionMinimums: '1-2M HHs',
  },
];

const data = {
  headers: [
    columnLabels.name,
    columnLabels.visitMinimums,
    columnLabels.attributionMinimums,
  ],
  body: mediumMinimums.map(minimum => [
    minimum.name,
    minimum.visitMinimums,
    minimum.attributionMinimums,
  ]),
} as const satisfies MinimumsTableData;

type MediumTableProps = {
  options: TableOptions;
};

export const mediumTable = (props: MediumTableProps): Slide =>
  minimumsTable({ data, options: props.options });
